var map = {
	"./ADA.png": 61,
	"./ADX.png": 62,
	"./AE.png": 63,
	"./ARDR.png": 64,
	"./ARK.png": 65,
	"./BAT.png": 66,
	"./BCC.png": 67,
	"./BCH.png": 68,
	"./BCN.png": 69,
	"./BLOCK.png": 70,
	"./BNB.png": 71,
	"./BNT.png": 72,
	"./BTC.png": 13,
	"./BTCD.png": 73,
	"./BTG.png": 74,
	"./BTM.png": 75,
	"./BTS.png": 76,
	"./CNX.png": 77,
	"./CVC.png": 78,
	"./DASH.png": 14,
	"./DCR.png": 79,
	"./DGB.png": 80,
	"./DGD.png": 81,
	"./DOGE.png": 82,
	"./EDG.png": 83,
	"./EMC2.png": 84,
	"./EOS.png": 85,
	"./ETC.png": 86,
	"./ETH.png": 87,
	"./ETHOS.png": 88,
	"./ETP.png": 89,
	"./FCT.png": 90,
	"./FUN.png": 91,
	"./GAME.png": 92,
	"./GAS.png": 93,
	"./GBYTE.png": 94,
	"./GNO.png": 95,
	"./GNT.png": 96,
	"./GRS.png": 97,
	"./GXS.png": 98,
	"./HSR.png": 99,
	"./ICN.png": 100,
	"./ICX.png": 101,
	"./KMD.png": 102,
	"./KNC.png": 103,
	"./LSK.png": 104,
	"./LTC.png": 15,
	"./MAID.png": 105,
	"./MCO.png": 106,
	"./MIOTA.png": 107,
	"./MNX.png": 108,
	"./MONA.png": 109,
	"./MTL.png": 110,
	"./NAV.png": 111,
	"./NEO.png": 112,
	"./NXS.png": 113,
	"./NXT.png": 114,
	"./OMG.png": 115,
	"./ONT.png": 116,
	"./PAY.png": 117,
	"./PIVX.png": 118,
	"./POT.png": 119,
	"./POWER.png": 120,
	"./PPC.png": 121,
	"./PPT.png": 122,
	"./PURA.png": 123,
	"./QASH.png": 124,
	"./QTUM.png": 125,
	"./RDN.png": 126,
	"./REP.png": 127,
	"./SALT.png": 128,
	"./SAN.png": 129,
	"./SC.png": 130,
	"./SKY.png": 131,
	"./SNGLS.png": 132,
	"./SNT.png": 133,
	"./START.png": 134,
	"./STEEM.png": 135,
	"./STORJ.png": 136,
	"./SYS.png": 137,
	"./TRX.png": 138,
	"./UBQ.png": 139,
	"./USDT.png": 140,
	"./VEN.png": 141,
	"./VTC.png": 142,
	"./WAVES.png": 143,
	"./WTC.png": 144,
	"./XEM.png": 145,
	"./XLM.png": 146,
	"./XMR.png": 16,
	"./XRP.png": 17,
	"./XTZ.png": 147,
	"./XUC.png": 148,
	"./XVG.png": 149,
	"./XZC.png": 150,
	"./ZEC.png": 151,
	"./ZEN.png": 152,
	"./ZRX.png": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;


//////////////////
// WEBPACK FOOTER
// ./src/img/crypto ^\.\/.*\.png$
// module id = 60
// module chunks = 0